import React from "react";
import { useTranslation } from "react-i18next";

export const Loading: React.FC<{ isOverlay?: boolean }> = ({ isOverlay = false }) => {
	const { t } = useTranslation();

	return (
		<div
			role="status"
			aria-live="polite"
			className={`flex items-center justify-center ${isOverlay ? "h-screen bg-black/30 absolute top-0 left-0 right-0 bottom-0 z-50" : "h-64"}`}
		>
			<div className="text-center">
				<div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
				<p className="mt-4 text-muted-foreground">{t("common.loading")}</p>
			</div>
		</div>
	);
};
